import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const TimeLeftContainer = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
`;
